export default "__VITE_ASSET__CO4BwP0e__"